import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../core/services/app-config.service';
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle';
import SwaggerUIStandalonePreset from 'swagger-ui-dist/swagger-ui-standalone-preset';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentationComponent implements OnInit, OnDestroy {
  
  serviceUrls = [
    {
      name: "User Management",
      url: AppConfigService.rootUrl + AppConfigService.apiDocsPath
    },
    {
      name: "Entity Management",
      url: AppConfigService.eoApiUrl + AppConfigService.apiDocsPath
    },
    {
      name: "Product Management",
      url: AppConfigService.productMangementUrl + AppConfigService.apiDocsPath
    },
    {
      name: "Order Management",
      url: AppConfigService.orderApiUrl + AppConfigService.apiDocsPath
    },
    {
      name: "Tax Management",
      url: AppConfigService.taxManagerApiUrl + AppConfigService.apiDocsPath
    },
    {
      name: "Registry Service",
      url: AppConfigService.registryServiceUrl + AppConfigService.apiDocsPath
    }
  ];

  swaggerInstance: any;

  constructor(private http: HttpClient, private authService: AuthService) {}

  ngOnInit() {
    this.selectService(0);
  }

  ngOnDestroy() {
    this.swaggerInstance = null;
  }

  selectService(index: number) {
    if (this.swaggerInstance) {
      const container = document.getElementById('swagger-ui');
      if (container) {
        container.innerHTML = '';
      }
      this.swaggerInstance = null;
    }

    const selectedUrl = this.serviceUrls[index].url;
    const baseUrl = this.extractBaseUrl(selectedUrl);

    this.http.get<any>(selectedUrl).subscribe((spec: any) => {
      spec.servers = [{ url: baseUrl }];
      const tokenResponse = this.authService['getAccessTokenResponse']();
      const token = tokenResponse?.access_token || '';
      
      this.swaggerInstance = SwaggerUIBundle({
        spec: spec,
        dom_id: '#swagger-ui',
        docExpansion: 'none',
        deepLinking: true,
        filter: true,
        layout: "BaseLayout",
        showExtensions: true,
        showCommonExtensions: true,
        defaultModelsExpandDepth: 0,
        supportedSubmitMethods: ['get', 'put', 'post', 'delete', 'options', 'head', 'patch', 'trace'],
        presets: [
          SwaggerUIBundle.presets.apis,
          SwaggerUIStandalonePreset
        ],
        plugins: [
          SwaggerUIBundle.plugins.DownloadUrl
        ],

        onComplete: () => {
          if (token) {
            this.swaggerInstance.preauthorizeApiKey('bearer-jwt', token);
          }
        },
        requestInterceptor: (req: any) => {

          if (token) {
            req.headers['Authorization'] = `Bearer ${token}`;
          }
          if (!req.url.includes(baseUrl)) {
            if (req.url.startsWith('http')) {
              const urlWithoutPath = req.url.split('//')[0] + '//' + req.url.split('//')[1].split('/')[0];
              req.url = req.url.replace(urlWithoutPath, urlWithoutPath + baseUrl.substring(baseUrl.indexOf('/', 8)));
            } 
            else if (req.url.startsWith('/')) {
              req.url = baseUrl + req.url;
            }
            else {
              req.url = baseUrl + '/' + req.url;
            }
          }
          
          return req;
        }
      });
    });
  }

  private extractBaseUrl(fullUrl: string): string {
    const urlParts = fullUrl.split('/openAPI');
    return urlParts[0];
  }
}